import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Footer from '../Footers/Footer';
import Header from '../Headers/Header';

const BookingHistory = () => {

    let navigate = useNavigate();

    let arr = [0, 1, 2, 3];

    let last_item = arr.length;

    return (
        <div className='myProfile'>
            <section className='bg-privacy-policy-top mb-5'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>My Profile</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='third_sec booking_histroy mt-5'>
                <div className='my_booking my-5'>
                    <div className='container my-5'>
                        <div className='row my-5'>
                            <div className='col-lg-12 '>
                                <button
                                    onClick={() => { navigate("/myprofile") }}
                                    className='btn btn-secondary bt-aboutus f-14 f-pop-med mt-5 bt-mybookings '>My Account</button>
                                <button className='ms-3 btn btn-danger bt-aboutus f-14 f-pop-med mt-5 bt-profile bx-shadow'>My Bookings</button>
                            </div>
                        </div>
                    </div>
                    <div className='container  my-5'>
                        <div className='row my-5'>
                            <div className='col-sm-8 '>
                                <p className='f-35 f-pop-med'>Booking History</p>
                            </div>
                            <div className='col-sm-4 '>
                                <select className='form-control form-select bg-e1 p-3 bg-e1 f-14 f-pop-med'>
                                    <option className='bg-e1 f-14 f-pop-med'>Filter</option>
                                    <option className='bg-e1 f-14 f-pop-med'>Completed Bookings</option>
                                    <option className='bg-e1 f-14 f-pop-med'>Canceled Bookings</option>
                                </select>
                            </div>
                            <div className='col-lg-12 mt-4 mb-5'>
                                <div className='crd-itm'>
                                    <div className='card crd-mxminwdth '>
                                        <div className='card-header border-0 bg-white'>
                                            <div className='head_table p-3'>
                                                <p className='f-pop-med f-14'>Booking id</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>Pickup Address</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>Dropoff Address</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>Date</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>Time</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>Amount</p>
                                                <div className='brdr-right-table'></div>
                                                <p className='f-pop-med f-14'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Open&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                                {/* <p className='f-pop-med f-14'>Open</p> */}

                                            </div>
                                        </div>
                                    </div>
                                    <div className='card crd-mxminwdth clr-bg-tab'>
                                        {arr.map((item, index) => {
                                            return (
                                                <div key={index} className='card-body p-3'>
                                                    <div className='body-content'>
                                                        <div className='booking-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                Booking id
                                                            </p>
                                                        </div>
                                                        <div className='pickup-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                I just filed two
                                                                applications and
                                                                had.
                                                            </p>
                                                        </div>
                                                        <div className='dropoff-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                I just filed two
                                                                applications and
                                                                had.
                                                            </p>
                                                        </div>
                                                        <div className='time-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                4:30 Pm
                                                            </p>
                                                        </div>
                                                        <div className='date-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                21 12 2021
                                                            </p>
                                                        </div>
                                                        <div className='amount-item'>
                                                            <p className='f-14 f-pop-reg'>
                                                                25$
                                                            </p>
                                                        </div>
                                                        <div className='open-item'>
                                                            <span className='f-14 f-pop-reg'>
                                                                Completed
                                                            </span>
                                                            <span onClick={() => { navigate("/singleBookingdetail") }} className='f-12 f-pop-med ms-4 viewdetails_booking_histroy'>View Details</span>
                                                        </div>
                                                    </div>
                                                    {(index !== last_item - 1) ?
                                                        <div className='border-btm-d5 mt-4 mx-4'>

                                                        </div> : <div className=' mb-2'>

                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    )
}

export default BookingHistory;